export default {"src":"/_next/static/media/uvercee-logo.b8bd82df.svg","height":38,"width":225,"blurWidth":0,"blurHeight":0};